import React from "react"
import PropTypes from "prop-types"
import { Button } from "react-bootstrap"
import classNames from "classnames"

const BulkActionsSubmitButton = (props) => (
    <Button
        block
        className={classNames("btn-primary bulk-actions-console-button bulk-actions-buttons-submit", {
            disabled: props.submitButtonIsDisabled,
        })}
        data-cy="bulk-actions-buttons-submit"
        onClick={async () => {
            const isConfirm = await swal({
                icon: props.submitButtonIcon,
                title: props.submitButtonSwalTitle,
                text: props.submitButtonSwalText,
                buttons: props.submitButtonSwalButtons,
            })
            if (isConfirm) {
                props.handleSubmit()
            }
        }}
    >
        {props.submitButtonLabel}
    </Button>
)
BulkActionsSubmitButton.propTypes = {
    // from app/static/frontend/search-new/containers/BulkActions/buttons/BulkActionsButtons
    submitButtonIcon: PropTypes.string,
    submitButtonIsDisabled: PropTypes.bool,
    submitButtonLabel: PropTypes.string,
    submitButtonSwalButtons: PropTypes.object,
    submitButtonSwalText: PropTypes.string,
    submitButtonSwalTitle: PropTypes.string,
    // from app/static/frontend/search-new/components/BulkActions/BulkActionsConsole
    // actually the onSubmit() from shared/forms/BulkActions/action-creators
    handleSubmit: PropTypes.func.isRequired,
}

export default BulkActionsSubmitButton
